import React from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';

import { IsUserLoggedInQuery } from '__generated__/IsUserLoggedInQuery.graphql';

const isUserLoggedInQuery = graphql`
  query IsUserLoggedInQuery {
    me {
      profile {
        isVerified
        firstName
        lastName
      }
    }
  }
`;

const IsUserLoggedIn = ({ children }: React.PropsWithChildren) => {
  const {
    me: {
      profile: { isVerified },
    },
  } = useLazyLoadQuery<IsUserLoggedInQuery>(isUserLoggedInQuery, {
    fetchPolicy: 'network-only',
  });

  if (!isVerified) {
    return null;
  }

  return <>{children}</>;
};

export default IsUserLoggedIn;
